<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="table-container" *ngIf="activityData">
  <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
    <div class="">
      <div class="search-container">
        <span class="fa fa-search form-control-feedback"></span>
        <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
          [(ngModel)]="searchValue">
      </div>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="message.dataGridAdmin"
      (click)="openReorder()" (keydown.enter)="openReorder()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
        <path style="fill:'#FFFFFF'"
          d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
      </svg>
      <span class="reload_text text-white">Settings</span>
    </div>
    <div class="">
      <div class="action-buttons-container d-flex gap-2">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="((qualityService.moduleName != 'AU' && showActionButtons) || audit())" (click)="openAddPopup()"
          (keydown.enter)="openAddPopup()" matTooltip="Add Extensions">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
          (keydown.enter)="openAuditTrail('overAll',0)">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Pdf')"
          (keydown.enter)="openReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshGridData()" (keydown.enter)="refreshGridData()" matTooltip="Refresh Grid">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>

  <table class="dynamic-table-container">
    <th style="min-width: 60px; text-align: center;"
      [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
      <div style="display: flex;">
        <div>
          <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
        </div>
      </div>
    </th>
    <th id="grid-header-container"
      *ngFor="let taskExtensionsDataForGridData of columnLists.fieldColumnarray; let ix = index;" [ngStyle]="{
            'min-width': taskExtensionsDataForGridData.width,
            'max-width': taskExtensionsDataForGridData.width,
            'overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap'}" class="sticky-dynamic-col1">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>{{taskExtensionsDataForGridData.fieldColumnarray}}</span>
        <div class="d-flex gap-2 align-items-center">
          <div class="sort" (click)="sortColumn(columnLists.columnsListarray[ix],taskExtensionsDataForGridData)"
            (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],taskExtensionsDataForGridData)">
            <div><i *ngIf="sortedDisplayColumn==taskExtensionsDataForGridData.fieldColumnarray && sortDirection=='asc'"
                class='fas fa-angle-up' style='font-size:11px'></i></div>
            <div><i *ngIf="sortedDisplayColumn==taskExtensionsDataForGridData.fieldColumnarray && sortDirection=='desc'"
                class='fas fa-angle-down' style='font-size:11px'></i></div>
            <img *ngIf="sortedDisplayColumn!=taskExtensionsDataForGridData.fieldColumnarray"
              src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>
    <th id="menu" class="sticky-col first-col"></th>
    <!-- search input row is added -->
    <tr>
      <td [class]="
          makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''
        "></td>
      <td *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
        [ngStyle]="{'min-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200,'max-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200}"
        class="sticky-dynamic-col1">
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
        </div>
      </td>
    </tr>
    <!-- data row -->
    <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
      [class.highlightRow]="list.childCheckBoxs == true">
      <td style="min-width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
              (change)="dataGridChildCheckBoxChecked($event, list, idx)">
          </div>
        </div>
      </td>
      <td *ngFor="let key of columnLists.columnsListarray1; let i = index;" (focus)="focusEmpty()"
        class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap'}" (mouseover)="cssfunction(i)" (click)="openEditPopup(list)"
        (keydown.enter)="openEditPopup(list)">
        <span *ngIf="key.dataType=='CHECKBOX'">
          <div class="gridCheckBoxes">
            <img *ngIf="list[key.columnsListarray]" src="../../../assets/img/cr_module/accessSymbol.svg" width="16"
              height="16" alt="access" />
            <img *ngIf="list[key.columnsListarray] == false" src="../../../assets/img/cr_module/noAcessSymbol.svg"
              width="16" height="16" alt="no access" />
          </div>
        </span>


        <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
              (click)="getClobData(list,key.columnsListarray)">
              <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
              <span class="ms-1">View</span>
            </button>
          </div>
        </span>

        <span [matTooltip]="list[key.columnsListarray]"
          *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">{{
          list[key.columnsListarray] }}</span>
        <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
      </td>
      <td class="sticky-col first-col">
        <div class="action-icons d-flex align-items-center gap-2">
          <span
            *ngIf="((qualityService.moduleName != 'AU' && showActionButtons) || audit()) && (list.STATUS == 'Approval Rejected' || list.STATUS == 'Review Rejected' || list.STATUS == 'Open')">
            <img src=" ../../../assets/img/cr_module/Edit.svg" width="16" height="16" alt="edit"
              matTooltip="Edit Extensions" (click)="openEditPopup(list)" (keydown.enter)="openEditPopup(list)" />
            <img src="../../../assets/img/cr_module/delete.svg" width="16" height="16" alt="delete"
              *ngIf="(qualityService.moduleName != 'AU' || (qualityService.moduleName == 'AU' && auService.isAuditor))"
              matTooltip="Delete Extensions" (click)="openDeletePopup(list)" (keydown.enter)="openDeletePopup(list)" />
          </span>
          <i class="fa-solid fa-clipboard" *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail"
            style="margin-left: 5px;" (click)="openAuditTrail('individual',list)"
            (keydown.enter)="openAuditTrail('individual',list)"></i>
        </div>
      </td>
    </tr>
  </table>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #updateMessagePopup>
  <div class="updateMessage-container">
    <span>Data has been not changed...</span>
  </div>
</ng-template>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="frozen-popup-content">
      <div class="row">
        <!-- Left Column: IDs and Status -->
        <div class="col-md-4">
          <div class="mb-2 d-flex" *ngIf="this.qualityService.moduleName=='CR'">
            <div class="w-50"><label for="acitivity"><b>Change Request ID :</b></label></div>
            <div class="w-50">
              <span class="tooltip-style" matTooltip="{{this?.qualityService?.activity?.crId}}">
                {{this?.qualityService?.activity?.crId}}
              </span>
            </div>
          </div>
          <div class="mb-2 d-flex" *ngIf="this.qualityService.moduleName=='CAPA'">
            <div class="w-50"><label for="acitivity"><b>CAPA ID :</b></label></div>
            <div class="w-50">
              <span class="tooltip-style" matTooltip="{{this.qualityService.activity.capaId}}">
                {{this.qualityService.activity.capaId}}
              </span>
            </div>
          </div>
          <div class="mb-2 d-flex" *ngIf="this.qualityService.moduleName=='DV'">
            <div class="w-50"><label for="acitivity"><b>Deviation ID :</b></label></div>
            <div class="w-50">
              <span class="tooltip-style" matTooltip="{{this.qualityService.activity.dvId}}">
                {{this.qualityService.activity.dvId}}
              </span>
            </div>
          </div>
          <div class="mb-2 d-flex" *ngIf="this.qualityService.moduleName=='IN'">
            <div class="w-50"><label for="acitivity"><b>Incident ID :</b></label></div>
            <div class="w-50">
              <span class="tooltip-style" matTooltip="{{this.qualityService.activity.inId}}">
                {{this.qualityService.activity.inId}}
              </span>
            </div>
          </div>
          <div class="mb-2 d-flex" *ngIf="this.qualityService.moduleName=='CC'">
            <div class="w-50"><label for="acitivity"><b>Complaint ID :</b></label></div>
            <div class="w-50">
              <span class="tooltip-style" matTooltip="{{this.qualityService.activity.ccId}}">
                {{this.qualityService.activity.ccId}}
              </span>
            </div>
          </div>
          <div class="mb-2 d-flex" *ngIf="this.qualityService.moduleName=='AU'">
            <div class="w-50"><label for="acitivity"><b>Audit ID :</b></label></div>
            <div class="w-50">
              <span class="tooltip-style" matTooltip="{{this.qualityService.activity.auId}}">
                {{this.qualityService.activity.auId}}
              </span>
            </div>
          </div>
          <div class="mb-2 d-flex">
            <div class="w-50"><label for="acitivity"><b>Overall Status :</b></label></div>
            <div class="w-50">{{this.qualityService.activity.status}}</div>
          </div>
          <div class="mb-2 d-flex"
            *ngIf="this.qualityService.moduleName=='CR' || this.qualityService.moduleName=='CAPA' || this.qualityService.moduleName=='DV' || this.qualityService.moduleName=='AU'">
            <div class="w-50" *ngIf="this.qualityService.moduleName!='AU'">
              <label for="owner"><b>Owner :</b></label>
            </div>
            <div class="w-50" *ngIf="this.qualityService.moduleName=='AU'">
              <label for="lead-auditor"><b>Lead Auditor :</b></label>
            </div>
            <div class="w-50" *ngIf="this.qualityService.moduleName!='AU'">
              {{this.qualityService.activity.ownerUserName}}</div>
            <div class="w-50" *ngIf="this.qualityService.moduleName=='AU'">
              {{this.qualityService.activity.leadAuditorUser}}</div>
          </div>
          <div class="mb-2 d-flex"
            *ngIf="this.qualityService.moduleName=='IN' || this.qualityService.moduleName=='QI' || this.qualityService.moduleName=='CC'">
            <div class="w-50"><label for="acitivity"><b>Evaluator :</b></label></div>
            <div class="w-50">{{this.qualityService.activity.evaluatorUser}}</div>
          </div>
          <div class="mb-2 d-flex">
            <div class="w-50"><label for="acitivity"><b>Expected Closure Date :</b></label></div>
            <div class="w-50 text-uppercase">
              {{this.qualityService.activity.expcetedClosureOn | date : (appService.getOneQmsDateFormat ) }}
            </div>
          </div>
        </div>

        <!-- Center Column: Main Description Editors -->
        <div class="col-md-4">
          <div class="mb-2" *ngIf="this.qualityService.moduleName=='CR'">
            <label for="acitivity">
              <b> {{qualityService.activityDynamicLabel?.['CURRENT_STATE']?.fieldName ?? 'Current State'}}:</b>
            </label>
            <div class="d-flex align-items-center">
              <div class="hideToolbar flex-grow-1">
                <st-editor id="changeDescription" [(ngModel)]="this.qualityService.activity.currentState"
                  [config]="config" [spellcheck]="true" class="task-editor" [disabled]="true"></st-editor>
              </div>
              <div class="angular-editor-edit ms-1" (click)="openEditor('Current State', 'eye')"
                (keydown.enter)="openEditor('Current State', 'eye')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="mb-2" *ngIf="this.qualityService.moduleName=='CAPA'">
            <label for="description"><b>
                {{qualityService.activityDynamicLabel?.['CAPA_DESCRIPTION']?.fieldName ?? 'CAPA Description'}}:
              </b></label>
            <div class="d-flex align-items-center">
              <div class="hideToolbar flex-grow-1">
                <st-editor [(ngModel)]="this.qualityService.activity.capaDescription" [config]="config"
                  class="task-editor" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="angular-editor-edit ms-1" (click)="openEditor('CAPA Description', 'eye')"
                (keydown.enter)="openEditor('CAPA Description', 'eye')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="mb-2" *ngIf="this.qualityService.moduleName=='DV'">
            <label for="description"><b>
                {{qualityService.activityDynamicLabel?.['DEVIATION_DESCRIPTION']?.fieldName ??
                'Deviation Description'}}:
              </b></label>
            <div class="d-flex align-items-center">
              <div class="hideToolbar flex-grow-1">
                <st-editor [(ngModel)]="this.qualityService.activity.dvDescription" [config]="config"
                  class="task-editor" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="angular-editor-edit ms-1" (click)="openEditor('Deviation Description', 'eye')"
                (keydown.enter)="openEditor('Deviation Description', 'eye')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="mb-2" *ngIf="this.qualityService.moduleName=='IN' || this.qualityService.moduleName=='QI'">
            <label for="description"><b>
                {{qualityService.activityDynamicLabel?.['IMPACT_DESCRIPTION']?.fieldName ??
                'Impact Description'}}:</b></label>
            <div class="d-flex align-items-center">
              <div class="hideToolbar flex-grow-1">
                <st-editor [(ngModel)]="this.qualityService.activity.impactDescription" [config]="config"
                  class="task-editor" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="angular-editor-edit ms-1" (click)="openEditor('Impact Description', 'eye')"
                (keydown.enter)="openEditor('Impact Description', 'eye')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="mb-2" *ngIf="this.qualityService.moduleName=='CC'">
            <label for="description"><b>
                {{qualityService.activityDynamicLabel?.['COMPLAINT_DESCRIPTION']?.fieldName ??
                'Complaint Description'}}:</b></label>
            <div class="d-flex align-items-center">
              <div class="hideToolbar flex-grow-1">
                <st-editor [(ngModel)]="this.qualityService.activity.complaintDescription" [config]="config"
                  class="task-editor" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="angular-editor-edit ms-1" (click)="openEditor('Complaint Description', 'eye')"
                (keydown.enter)="openEditor('Complaint Description', 'eye')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column: Additional Editors -->
        <div class="col-md-4">
          <div class="mb-2" *ngIf="this.qualityService.moduleName=='CR'">
            <label for="description"><b>
                {{qualityService.activityDynamicLabel?.['PROPOSED_CHANGE']?.fieldName ??
                'Proposed Change'}}:</b></label>
            <div class="d-flex align-items-center">
              <div class="hideToolbar flex-grow-1">
                <st-editor [(ngModel)]="this.qualityService.activity.proposedChange" [config]="config"
                  class="task-editor" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="angular-editor-edit ms-1" (click)="openEditor('Proposed Change', 'eye')"
                (keydown.enter)="openEditor('Proposed Change', 'eye')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="mb-2" *ngIf="this.qualityService.moduleName=='CAPA'">
            <label for="summary"><b>
                {{qualityService.activityDynamicLabel?.['INVESTIGATION_SUMMARY']?.fieldName ??
                'Investigation Summary'}}:</b></label>
            <div class="d-flex align-items-center">
              <div class="hideToolbar flex-grow-1">
                <st-editor [(ngModel)]="this.qualityService.activity.investigationSummary" [config]="config"
                  class="task-editor" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="angular-editor-edit ms-1" (click)="openEditor('Investigation Summary', 'eye')"
                (keydown.enter)="openEditor('Investigation Summary', 'eye')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="mb-2" *ngIf="this.qualityService.moduleName=='IN' || this.qualityService.moduleName=='QI'">
            <label for="description"><b>{{qualityService.activityDynamicLabel?.['DESCRIPTION']?.fieldName ??
                'Description'}}:</b></label>
            <div class="d-flex align-items-center">
              <div class="hideToolbar flex-grow-1">
                <st-editor [(ngModel)]="this.qualityService.activity.description" [config]="config" class="task-editor"
                  [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="angular-editor-edit ms-1" (click)="openEditor('Description', 'eye')"
                (keydown.enter)="openEditor('Description', 'eye')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="mb-2" *ngIf="this.qualityService.moduleName=='CC'">
            <label for="initial-assessment"><b>
                {{qualityService.activityDynamicLabel?.['INITIAL_ASSESSMENT']?.fieldName ??
                'Initial Assessment'}}:</b></label>
            <div class="d-flex align-items-center">
              <div class="hideToolbar flex-grow-1">
                <st-editor [(ngModel)]="this.qualityService.activity.initialAssessment" [config]="config"
                  class="task-editor" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="angular-editor-edit ms-1" (click)="openEditor('Initial Assessment', 'eye')"
                (keydown.enter)="openEditor('Initial Assessment', 'eye')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr style="color: #cfcfcf;">
    <div style="max-height: 250px; overflow-y: scroll; overflow-x: hidden; margin: 15px;">
      <div class="row">
        <div class="col-md-3">
          <div><label id="extension-validation" for="email">{{dynamicLabel['EXTENSION_TYPE']}}</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="taskExtensionsFieldData.extensionType"
            (closed)="extensionTypeTxt=''" (click)="focusmethod('extensionTypeSearch')"
            (keydown.enter)="focusmethod('extensionTypeSearch')" [disabled]="isFrozen ">
            <input type="search" id="extensionTypeSearch" class="dropdownsearchstyle" [(ngModel)]="extensionTypeTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option (click)="extnType(item)" (keydown.enter)="extnType(item)"
              *ngFor="let item of extensionTypeList| assessmentSearch :extensionTypeTxt" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3"
          *ngIf="taskExtensionsFieldData.extensionType=='Findings'||taskExtensionsFieldData.extensionType=='Action'">
          <div><label id="actionDetails-validation" for="email">{{qualityService.moduleName=='AU' ? 'Finding Detail' :
              'Action Detail'}}</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="taskExtensionsFieldData.actionId"
            (closed)="extensionTypeTxt=''" (click)="focusmethod('action-name-search')"
            (keydown.enter)="focusmethod('action-name-search')" [disabled]="isFrozen">
            <input type="search" id="action-name-search" class="dropdownsearchstyle" [(ngModel)]="extensionTypeTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option (click)="actiondetailchange(item)" (keydown.enter)="actiondetailchange(item)"
              *ngFor="let item of actionNameListDropdown| assessmentSearch :extensionTypeTxt" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3"
          *ngIf="taskExtensionsFieldData.extensionType=='Findings'||taskExtensionsFieldData.extensionType=='Action'">
          <div>
            <label id="reviewedBy-validation" for="email">
              {{qualityService.moduleName=='AU' ? 'Finding Detail' : 'Action Detail'}}
            </label>
          </div>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="taskExtensionsFieldData.actionDetails" disabled></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div><label id="currentDue-validation" for="email">
              <!-- Current Expected Closure Date -->{{dynamicLabel['CURRENT_DUE_DATE']}}
            </label><span class="mandatory-symbol">*</span></div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="datePickerConfiguration"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="taskExtensionsFieldData.currentDueDate"
            (ngModelChange)="currentDueDateOnChange($event)" [disabled]="true">
        </div>
        <div class="col-md-3">
          <div><label id="extensionRequiredTill-validation"
              for="email">{{dynamicLabel['EXTENSION_REQUIRED_TILL']}}</label><span class="mandatory-symbol">*</span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker
            [disabled]="!taskExtensionsFieldData.extensionType || isFrozen"
            [bsConfig]="$exceedClosureDateConfiguration()" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="taskExtensionsFieldData.extensionRequiredTill"
            (ngModelChange)="extensionRequiredTillOnChange($event)">
        </div>
        <div class="col-md-3" *ngIf="!visibleAddButton">
          <div><label for="email">{{dynamicLabel['STATUS']}}</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="taskExtensionsFieldData.status" disabled>
        </div>
        <div class="col-md-3">
          <div>
            <label for="email">{{dynamicLabel['REVIEWER']}}</label>
            <span class="mandatory-symbol">*</span>
            <label *ngIf="message.showSwitchUser" for="email" (click)="openswitchuser('Extension Reviewer')"
              (keydown.enter)="openswitchuser('Extension Reviewer')"><a><img title="Switch User"
                  src="..//..//../assets/img/user-switch.png" width="25" height="25" alt="switch"></a></label>
            <!-- Removed the owner-validation label -->
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="qualityService.selectedExtensionReview"
            [ngClass]="{'odd-item-mat-select':isExtensionReviewOdd==qualityService.selectedExtensionReview}"
            (closed)="reviewedByTxt=''" (click)="focusmethod('reviewedBySearch')"
            (keydown.enter)="focusmethod('reviewedBySearch')" [disabled]="isFrozen">
            <input type="search" id="reviewedBySearch" class="dropdownsearchstyle" [(ngModel)]="reviewedByTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of listOfReviewerUsersDropdown | assessmentSearch : reviewedByTxt"
              (onSelectionChange)="onReviewedSelect($event, item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div><label id="approvedBy-validation" for="email">{{dynamicLabel['APPROVER']}}</label><span
              class="mandatory-symbol">*</span>
            <label *ngIf="message.showSwitchUser" for="email" (click)="openswitchuser('Extension Approver')"
              (keydown.enter)="openswitchuser('Extension Approver')"><a><img title="Switch User"
                  src="..//..//../assets/img/user-switch.png" width="25" height="25" alt="switch"></a></label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="qualityService.selectedExtensionApprove"
            [ngClass]="{'odd-item-mat-select':isExtensionApproveOdd==qualityService.selectedExtensionApprove}"
            (closed)="approvedByTxt=''" (click)="focusmethod('approvedBySearch')"
            (keydown.enter)="focusmethod('approvedBySearch')" [disabled]="isFrozen">
            <input type="search" id="approvedBySearch" class="dropdownsearchstyle" [(ngModel)]="approvedByTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of listOfApproverUsersDropdown| assessmentSearch :approvedByTxt"
              (onSelectionChange)="onApprovedBySelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-6">
          <div><label id="justification-validation" for="email">{{dynamicLabel['JUSTIFICATION']}}</label><span
              class="mandatory-symbol">*</span></div>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
            [matTooltip]="taskExtensionsFieldData.justification" [(ngModel)]="taskExtensionsFieldData.justification"
            (focusout)="onFieldFocusout()" [disabled]="isFrozen"></textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addAndEditFunction(taskExtensionsFieldData)"
      *ngIf="visibleAddButton">
      <i class="fas fa-plus"></i> Add
    </button>
    <button style="margin-left: 1%;" mat-stroked-button class="addButton" *ngFor="let button of buttonList"
      (click)="dynamicButtonClick(taskExtensionsFieldData, button)">
      <i class="fas fa-user-edit"></i> {{button}}
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #confirmWithReasonPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelFunc()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ buttonLabel }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-sm-12" *ngIf="buttonLabel=='Review'||buttonLabel==='Approve'">
          <div><label id="buttonLabel-validation" for="email">{{buttonLabel}}</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedStatus">
            <mat-radio-button class="tp-radio-button" *ngFor="let status of reviewStatus" [value]="status">
              {{status}}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="col-md-12" *ngIf="isEsignRequired">
          <div class=""><label for="username ">User Name</label><span class="mandatory-symbol">*</span></div>
          <div class=""> <input id="username" style="height: 80% !important;" class="input-filed-continers" type="text"
              [(ngModel)]="userName" disabled>
          </div>
        </div>
        <div class="col-md-12" *ngIf="(isEsignRequired && !isAdenabled)">
          <div class=""><label id="password-validation" for="pass">Password</label><span
              class="mandatory-symbol">*</span></div>
          <div class=""> <input id="EsignRequiredPassword" autocomplete="off" onpaste="return false;"
              ondrop="return false;" style="height: 80% !important;" class="input-filed-continers"
              [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password"
              (focusout)="onPasswordFieldFocusout()" noCopyPaste>
            <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
              <i
                [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
            </span>
          </div>
        </div>
        <div class="col-md-12">
          <div><label for="comments" id="reason-validation">Comments</label><span class="mandatory-symbol">*</span>
          </div>
          <textarea id="reason" rows="4" class="textarea-filed-continers" type="text" [(ngModel)]="reason"></textarea>
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button *ngIf="buttonLabel != ''" mat-stroked-button class="addButton" (click)="confirmWithReasonFunc()">
        {{buttonLabel}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label id="deleteReason-validation" for="email">Reason For Delete</label><span
              class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea" type="text" class="input-filed-textarea uppercase" rows="4" cols="50"
            [(ngModel)]="taskExtensionsFieldData.deleteReason" (focusout)="onFieldFocusout()"></textarea>
        </div>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction(taskExtensionsFieldData)">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()"></app-switchuser>
<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmit()"></app-grid-reorder>
<app-editor #clobViewPopup></app-editor>

<!-- Add the missing editor template -->
<ng-template #editor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelEditor()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ editorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div><br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]=" allowEditing ? includeButtons : excludeButtons"
        [spellcheck]="true" (paste)="onPaste($event)"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" *ngIf="allowEditing" (click)="saveEditor(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>